import BookingForm from "@/components/BookingForm";

export default function BookingSection() {
  return (
    <section data-testid="booking-section" id="booking" className="section-pad bg-sand">
      <div className="container-pad mx-auto max-w-6xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="eyebrow justify-center">
            <span className="w-8 h-px bg-teal-500" />
            Online Booking
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-navy tracking-tight mt-5 leading-[1.15]">
            Request transportation in <strong className="font-bold text-teal-600">minutes.</strong>
          </h2>
          <p className="mt-5 text-base md:text-lg text-navy/65 leading-relaxed font-light">
            Submit your details below. A scheduling specialist will reach out to confirm pricing, vehicle assignment, and pickup time.
          </p>
        </div>
        <BookingForm />
      </div>
    </section>
  );
}
